import { render, staticRenderFns } from "./MetadataDock.vue?vue&type=template&id=e72f5646&scoped=true"
import script from "./MetadataDock.vue?vue&type=script&lang=js"
export * from "./MetadataDock.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MetadataDock.vue?vue&type=style&index=1&id=e72f5646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72f5646",
  null
  
)

export default component.exports